import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitClickToCall } from "../../../../utils/clickToCallApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import DynamicTemplate from "../../../../components/Apps/ClickToCall/Template/DynamicTemplate";

//Import Tabs
import ContentTab from "../../../../components/Apps/ClickToCall/ContentTab";
import PositionTab from "../../../../components/Apps/ClickToCall/PositionTab";
import SettingTab from "../../../../components/Apps/ClickToCall/SettingTab";
import StyleTab from "../../../../components/Apps/ClickToCall/StyleTab";

export default function CreateClickToCall() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Content");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Call_Us_Temp");
    const [selectedLayout, setSelectedLayout] = useState("call_us_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("call-us.png");
    const [clickToCallTabData, setClickToCallTabData] = useState({
        is_website_frontend: "", 
        content_phone_number: "+1-408-123-4567",  
        content_is_show_button_icon: 1,  
        content_button_text: "Call Us",  
        content_call_window_picture: "",  
        content_call_window_name: "Call Us Now",  
        content_call_window_caption: "",  
        content_call_window_message: "",  
        content_call_window_format_phone_number: 1,  
        postion_postion_type: "right-side",  
        setting_pages_type: "All_Pages",  
        setting_devices_type: ["Desktop", "Tablets", "Phones"],  
        setting_visitors_type: "All_Visitors",  
        setting_schedule_days: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],  
        setting_schedule_is_set_the_time_schedule: 1,  
        setting_schedule_start_time: "12:00 AM",  
        setting_schedule_end_time: "1:00 AM",   
        setting_schedule_time_zone: "", 
        setting_open_call_window_triggers_is_on_page_load: 1,  
        setting_open_call_window_triggers_time_on_page: "",  
        setting_open_call_window_triggers_time_on_site: "",  
        setting_open_call_window_triggers_scroll_position: "",  
        setting_open_call_window_triggers_is_exit_intent: 1,     
        style_button_color: "",     
        style_button_icon_text_color: "",     
        style_window_background_color: "",     
        style_window_message_color: "",     
        style_window_phone_number_color: "",     
        style_font_type: "",   
        style_button_size: "50",  
        style_name_font_size: "14px",     
        style_caption_font_size: "14px",     
        style_message_font_size: "14px",     
        style_phone_number_font_size: "14px",       
        style_button_animation: "",     
        style_animation_interval: "",     
        style_custom_css: "",     
        style_custom_js: "",     
    });

    // Set Template Setting And Texts when activeTemplateSection changes
    useEffect(() => {
        let content_button_text = "";
        let content_call_window_picture = "";
        let content_call_window_name = "";
        let content_call_window_caption = "";
        let content_call_window_message = "";
        let style_button_color = "";
        let style_button_icon_text_color = "";
        let style_window_background_color = "";
        let style_window_message_color = "";
        let style_window_phone_number_color = "";
    
        switch (activeTemplateSection) {
            case "Call_Us_Temp":
                content_button_text = "Call Us";
                content_call_window_picture = `${process.env.PUBLIC_URL}/click-to-call/templates/sale-image.jpg`;
                content_call_window_name = "Call Us Now";
                content_call_window_caption = "";
                content_call_window_message = "";
                style_button_color = "#212223";
                style_button_icon_text_color = "#fff";
                style_window_background_color = "#212223";
                style_window_message_color = "#fff";
                style_window_phone_number_color = "#76f82b";
                break;
            case "Sale_Temp":
                content_button_text = "";
                content_call_window_picture = `${process.env.PUBLIC_URL}/click-to-call/templates/sale-image.jpg`;
                content_call_window_name = "John";
                content_call_window_caption = "Sales manager";
                content_call_window_message = "Looking for the best offer? Call me I'll be happy to find your perfect option.";
                style_button_color = "#ff3636";
                style_button_icon_text_color = "#000";
                style_window_background_color = "#fff";
                style_window_message_color = "#303030";
                style_window_phone_number_color = "#ff1717";
                break;
            case "Consultation_Temp":
                content_button_text = "";
                content_call_window_picture = `${process.env.PUBLIC_URL}/click-to-call/templates/consultation-image.jpg`;
                content_call_window_name = "John";
                content_call_window_caption = "Sales manager";
                content_call_window_message = "Looking for the best offer? Call me I'll be happy to find your perfect option.";
                style_button_color = "#b0f540";
                style_button_icon_text_color = "#000";
                style_window_background_color = "#b0f540";
                style_window_message_color = "#466219";
                style_window_phone_number_color = "#000";
                break;
            case "Support_Temp":
                content_button_text = "Need Help?";
                content_call_window_picture = `${process.env.PUBLIC_URL}/click-to-call/templates/support-image.jpg`;
                content_call_window_name = "Nancy";
                content_call_window_caption = "Support Manager";
                content_call_window_message = "Hey there Need help? I'm here for you, so just give me a call.";
                style_button_color = "#fff700";
                style_button_icon_text_color = "#000";
                style_window_background_color = "#fff700";
                style_window_message_color = "#373600";
                style_window_phone_number_color = "#000";
                break;
            case "Booking_Temp":
                content_button_text = "Booking a Room";
                content_call_window_picture = `${process.env.PUBLIC_URL}/click-to-call/templates/bookin-image.jpg`;
                content_call_window_name = "Lisa";
                content_call_window_caption = "Client Manager";
                content_call_window_message = "Looking for a place to stay inNYC? I've got the very thing for you, so call me.";
                style_button_color = "#fe8100";
                style_button_icon_text_color = "#000";
                style_window_background_color = "#fe8100";
                style_window_message_color = "#373600";
                style_window_phone_number_color = "#feae5c";
                break;
            case "Floating_Call_Button_Temp":
                content_button_text = "+1-408-123-4567";
                content_call_window_picture = `${process.env.PUBLIC_URL}/click-to-call/templates/sale-image.jpg`;
                content_call_window_name = "";
                content_call_window_caption = "";
                content_call_window_message = "Click the phone number to call.";
                style_button_color = "#0094fe";
                style_button_icon_text_color = "#000";
                style_window_background_color = "#0094fe";
                style_window_message_color = "#fff";
                style_window_phone_number_color = "#000";
                break;
            default:
                content_button_text = "Call Us";
                content_call_window_picture = "";
                content_call_window_name = "Call Us Now";
                content_call_window_caption = "";
                content_call_window_message = "";
                style_button_color = "";
                style_button_icon_text_color = "";
                style_window_background_color = "";
                style_window_message_color = "";
                style_window_phone_number_color = "";
        }
    
        // Update clickToCallTabData state with the data
        setClickToCallTabData((prevData) => ({
            ...prevData,
            content_button_text: content_button_text,
            content_call_window_picture: content_call_window_picture,
            content_call_window_name: content_call_window_name,
            content_call_window_caption: content_call_window_caption,
            content_call_window_message: content_call_window_message,
            style_button_color: style_button_color,
            style_button_icon_text_color: style_button_icon_text_color,
            style_window_background_color: style_window_background_color,
            style_window_message_color: style_window_message_color,
            style_window_phone_number_color: style_window_phone_number_color,
        }));
    
    }, [activeTemplateSection]);

    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled Click To Call");
    const [newWidgetName, setNewWidgetName] = useState("");

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updateClickToCallTabData = (key, value) => {
        setClickToCallTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
    }; 

    const menuItems = [
      { key: "Content", icon: "content.png", label: "Content" },
      { key: "Position", icon: "position.png", label: "Position" },
      { key: "Setting", icon: "setting.png", label: "Settings" },
      { key: "Style", icon: "style.png", label: "Style" },
    ];

    // Handle Source Tab input change
    const handleActiveTemplateInputChange = (event) => {
        setActiveTemplateSection(event.target.value);
        //Get the currently checked radio button
        const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
        if (selectedRadio) {
            const layoutTypeValue = selectedRadio.dataset.layout_type;
            const template_image = selectedRadio.dataset.template_image;
            setSelectedLayout(layoutTypeValue);
            setSelectedTemplateImage(template_image);
        } else {
            alert('Please select a template');
        }
    };

    //Submit Form data
    const submitForm = async (e) => {
        e.preventDefault();

        setIsSubmitting(true);
        try {
            const formData = new FormData();

            // Append text fields
            formData.append("name", widgetName);
            formData.append("template_name", activeTemplateSection);
            formData.append("template_image", selectedTemplateImage);
            formData.append("layout_name", selectedLayout);
            formData.append("layout_type", selectedLayout);
            formData.append("app_type", "Click_To_Call");
    
            // Append settings as JSON string
            formData.append(
                "settings",
                JSON.stringify(
                    Object.entries(clickToCallTabData).map(([key, value]) => ({
                        setting_key: key,
                        setting_value: value,
                    }))
                )
            );

            // Check if content_call_window_picture is a File and append it
            if (clickToCallTabData.content_call_window_picture) {
                // If it's a File object (newly uploaded), append it directly
                if (clickToCallTabData.content_call_window_picture instanceof File) {
                    formData.append("content_call_window_picture", clickToCallTabData.content_call_window_picture); 
                } 
                // If it's a string (from predefined template), just send the image file name
                else if (typeof clickToCallTabData.content_call_window_picture === 'string') {
                    const imageName = clickToCallTabData.content_call_window_picture.split('/').pop();
                    formData.append("content_call_window_picture", imageName);
                }
            }
            
            //Api Call
            let api_response = await submitClickToCall(formData);

            //Check Responce
            if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/click-to-call');
                }, 2000); 
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error('Oops Something Wrong. Please Try Again!' + error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="Click To Call" app_type="Click_To_Call" app_slug="click-to-call"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Call_Us_Temp" data-layout_type="call_us_layout" data-template_image="call-us.png" checked={activeTemplateSection === "Call_Us_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/click-to-call/templates/call-us.png`} alt="call-us" />
                                    </div>
                                    <div className="content_sub">Call Us</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Sale_Temp" data-layout_type="sale_layout" data-template_image="sale.png" checked={activeTemplateSection === "Sale_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/click-to-call/templates/sale.png`} alt="sale" />
                                    </div>
                                    <div className="content_sub">Sale</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Consultation_Temp" data-layout_type="consultation_layout" data-template_image="consultation.png" checked={activeTemplateSection === "Consultation_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/click-to-call/templates/consultation.png`} alt="consultation" />
                                    </div>
                                    <div className="content_sub">Consultation</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Support_Temp" data-layout_type="support_layout" data-template_image="support.png" checked={activeTemplateSection === "Support_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/click-to-call/templates/support.png`} alt="support" />
                                    </div>
                                    <div className="content_sub">Support</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Booking_Temp" data-layout_type="booking_layout"  data-template_image="booking.png" checked={activeTemplateSection === "Booking_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/click-to-call/templates/booking.png`} alt="booking" />
                                    </div>
                                    <div className="content_sub">Booking</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Floating_Call_Button_Temp" data-layout_type="floating_call_button_layout" data-template_image="floating-call-button.png" checked={activeTemplateSection === "Floating_Call_Button_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/click-to-call/templates/floating-call-button.png`} alt="floating-call-button" />
                                    </div>
                                    <div className="content_sub">Floating Call Button</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/click-to-call/icons//${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Content" && (
                              <ContentTab updateClickToCallTabData={updateClickToCallTabData} clickToCallTabData={clickToCallTabData}/>
                            )}
                            {activeSection === "Position" && (
                              <PositionTab updateClickToCallTabData={updateClickToCallTabData} clickToCallTabData={clickToCallTabData}/>
                            )}
                            {activeSection === "Setting" && (
                              <SettingTab updateClickToCallTabData={updateClickToCallTabData} clickToCallTabData={clickToCallTabData}/>
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updateClickToCallTabData={updateClickToCallTabData} clickToCallTabData={clickToCallTabData}/>
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper">
                    <div className="source-header-row click-to-call-header">
                        <h2><Link to="/customer/apps/click-to-call"><i className="fa fa-angle-left" aria-hidden="true"></i> Back</Link></h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/images/app-icon/app-icon-3.svg`} alt="app-icon-3"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/click-to-call/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/click-to-call" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">Click To Call <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Check template type*/}
                    {activeTemplateSection === "Call_Us_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData} />
                    )}
                    {activeTemplateSection === "Sale_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Consultation_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Support_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Booking_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                    {activeTemplateSection === "Floating_Call_Button_Temp" && (
                      <DynamicTemplate selectedTemplate={activeTemplateSection} clickToCallTabData={clickToCallTabData}/>
                    )}
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 